<template id="eventList">
  <div
    class="container"
    id="event"
    v-loading="floading"
    element-loading-background="transparent"
  >
    <section>
      <div class="row">
        <div class="col-lg-9 pr-lg-4">
          <!-- 活動列表 -->
          <div class="event-list section-group">
            <h2 class="section-title"> {{ $t('Activitys.ActiveList.msg') }}</h2>
            <div
              class="event-list card"
              v-for="(activedata, index) in activeList"
              :key="index"
            >
              <div class="card-header">
                <h3 class="card-title">{{ activedata.year }}</h3>
                <div class="card-tools">
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <el-table :data="activedata.datalist">
                  <el-table-column :label="$t('Activitys.ActiveList.favor')" width="60">
                    <template slot-scope="scope">
                      <a
                        href="javascript:void(0)"
                        @click="addfavorite(scope.row.id, 0, 3, null)"
                        ><i
                          class="fas fa-bookmark fa-fw fa-sm"
                          v-if="scope.row.isCollection"
                          aria-hidden="true"
                        ></i
                        ><i
                          class="far fa-bookmark fa-fw fa-sm"
                          aria-hidden="true"
                          v-else
                        ></i
                      ></a>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('Activitys.ActiveList.sgL_ActivityDateF')"
                    prop="sgL_ActivityDateF"
                    width="100"
                  ></el-table-column>
                  <el-table-column :label="$t('Activitys.ActiveList.KMKeywor')">
                    <template slot-scope="scope">
                      <router-link
                        target="_blank"
                        :title="scope.row.sgL_KMKeyworld"
                        v-bind:to="{
                          name: 'eventview',
                          params: {
                            id: scope.row.id,
                          },
                        }"
                      >
                        <span
                          v-if="scope.row.sgL_RView >= 2000"
                          class="icon-hot"
                        ></span>
                        <span
                          v-if="scope.row.sgL_Recommend == true"
                          class="icon-featured"
                        ></span>
                        <span
                          class="event-title icon-album"
                          :title="`${$t('Activitys.ActiveList.sum')}${scope.row.photoCount}${$t('Activitys.ActiveList.photoCount')}`"
                          v-if="
                            scope.row.photoCount && scope.row.photoCount > 0
                          "
                        >
                        </span>
                        <span>{{ scope.row.sgL_Title }}</span>
                      </router-link>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('Activitys.ActiveList.sgL_TypeF')"
                    width="70"
                    prop="sgL_TypeF"
                  ></el-table-column>
                  <el-table-column
                    :label="$t('Activitys.ActiveList.sgL_AreaF')"
                    width="70"
                    prop="sgL_AreaF"
                  ></el-table-column>
                  <el-table-column
                    :label="$t('Activitys.ActiveList.sgL_StatusF')"
                    prop="sgL_StatusF"
                    width="100"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div
            class="event-list section-group"
            v-if="activeList2 && activeList2.length > 0"
          >
            <h2 class="section-title">{{ $t('Activitys.ActiveList.msg2') }}</h2>
            <div
              class="event-list card"
              v-for="(activedata, index) in activeList2"
              :key="index"
            >
              <div class="card-header">
                <h3 class="card-title">{{ activedata.year }}</h3>
                <div class="card-tools">
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <el-table :data="activedata.datalist">
                  <el-table-column :label="$t('Activitys.ActiveList.favor')" width="60">
                    <template slot-scope="scope">
                      <a
                        href="javascript:void(0)"
                        @click="addfavorite(scope.row.id, 0, 3, null)"
                        ><i
                          class="fas fa-bookmark fa-fw fa-sm"
                          v-if="scope.row.isCollection"
                          aria-hidden="true"
                        ></i
                        ><i
                          class="far fa-bookmark fa-fw fa-sm"
                          aria-hidden="true"
                          v-else
                        ></i
                      ></a>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('Activitys.ActiveList.sgL_ActivityDateF')"
                    prop="sgL_ActivityDateF"
                    width="100"
                  ></el-table-column>
                  <el-table-column :label="$t('Activitys.ActiveList.KMKeywor')">
                    <template slot-scope="scope">
                      <router-link
                        target="_blank"
                        :title="scope.row.sgL_KMKeyworld"
                        v-bind:to="{
                          name: 'eventview',
                          params: {
                            id: scope.row.id,
                          },
                        }"
                      >
                        <span
                          v-if="scope.row.sgL_RView >= 2000"
                          class="icon-hot"
                        ></span>
                        <span
                          v-if="scope.row.sgL_Recommend == true"
                          class="icon-featured"
                        ></span>
                        <span
                          class="event-title icon-album"
                          :title="`${$t('Activitys.ActiveList.sum')}${scope.row.photoCount}${$t('Activitys.ActiveList.photoCount')}`"
                          v-if="
                            scope.row.photoCount && scope.row.photoCount > 0
                          "
                        >
                        </span>
                        <span>{{ scope.row.sgL_Title }}</span>
                      </router-link>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('Activitys.ActiveList.sgL_TypeF')"
                    width="70"
                    prop="sgL_TypeF"
                  ></el-table-column>
                  <el-table-column
                    :label="$t('Activitys.ActiveList.sgL_AreaF')"
                    width="70"
                    prop="sgL_AreaF"
                  ></el-table-column>
                  <el-table-column
                    :label="$t('Activitys.ActiveList.sgL_StatusF')"
                    prop="sgL_StatusF"
                    width="100"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <!-- ./活動列表 -->
        </div>
        <div class="col-lg-3 mt-lg-4">
          <!-- 篩選 -->
          <div class="event-filter section-group">
            <h2 class="side-title">{{ $t('Activitys.ActiveList.screen') }}</h2>
            <div class="card p-3 margin-bottom">
              <el-form :model="selectParams" ref="selectParams">
                <el-form-item :label="$t('Activitys.ActiveList.KMKeywor')">
                  <el-input v-model="selectParams.title"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Activitys.ActiveList.activitydate')">
                  <el-date-picker
                    style="width: 277px"
                    v-model="selectParams.data"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="-"
                    :start-placeholder="$t('Activitys.ActiveList.startdate')"
                    :end-placeholder="$t('Activitys.ActiveList.enddate')"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('Activitys.ActiveList.city')">
                  <el-select
                    v-model="selectParams.city"
                    clearable
                    :placeholder="$t('Activitys.ActiveList.placeholder')"
                  >
                    <el-option
                      v-for="city in EventCityList"
                      :key="city.id"
                      :label="city.sgL_NewName"
                      :value="city.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('Activitys.ActiveList.type')">
                  <el-checkbox-group v-model="selectParams.type" size="small">
                    <el-checkbox-button
                      v-for="item in EventTypeList"
                      :key="item.id"
                      :label="item.id"
                      >{{ item.sgL_NewName }}</el-checkbox-button
                    >
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item :label="$t('Activitys.ActiveList.sgL_StatusF')">
                  <el-checkbox-group v-model="selectParams.status" size="small">
                    <el-checkbox-button
                      v-for="item in EventStatusList"
                      :key="item.id"
                      :label="item.id"
                      >{{ item.sgL_NewName }}</el-checkbox-button
                    >
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item :label="$t('Activitys.ActiveList.remark')">
                  <el-checkbox-group v-model="selectParams.remark" size="small">
                    <el-checkbox-button
                      v-for="item in EventRemarkList"
                      :key="item.id"
                      :label="item.id"
                      >{{ item.sgL_NewName }}</el-checkbox-button
                    >
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    @click="refresh()"
                    icon="fa fa-undo fa-fw fa-sm"
                    class="btn btn-block btn-primary"
                    >{{ $t('Activitys.ActiveList.refresh') }}</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </div>
          <!-- /.篩選 -->

          <!-- 提供活動資訊 -->
          <div class="section-group btn-fixed">
            <el-button
              @click="toSendMessage()"
              type="primary"
              icon="fa fa-fist-raised fa-fw fa-sm mr-1"
              class="btn btn-block btn-primary"
              >{{ $t('Activitys.ActiveList.SendMessage') }}</el-button
            >
          </div>
          <!-- ./提供活動資訊 -->

          <!-- 廣告 -->
          <div class="ad section-group">
            <div class="row">
              <div class="col-12">
                <ins
                  class="adsbygoogle"
                  style="display: inline-block; width: 300px; height: 250px"
                  data-ad-client="ca-pub-8370308321819212"
                  data-ad-slot="7350126089"
                ></ins>
              </div>
            </div>
          </div>
          <!-- ./廣告 -->
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import bases from "../../api/httpApi/base";
export default {
  data() {
    return {
      activeList: [],
      activeList2: [],
      floading: true,
      EventTypeList: null,
      EventStatusList: null,
      EventRemarkList: null,
      EventCityList: null,
      loading: true,
      base: null,
      selectParams: {
        title: null,
        type: [],
        data: null,
        city: null,
        status: [],
        remark: [],
      },
    };
  },
  watch: {
    "selectParams.title": {
      handler: function (newvalue, oldvalue) {
        if (newvalue != oldvalue) {
          this.GetEventList();
        }
      },
    },
    "selectParams.type": {
      handler: function (newvalue, oldvalue) {
        // console.log(newvalue);
        if (newvalue != oldvalue) {
          this.GetEventList();
        }
      },
    },
    "selectParams.data": {
      handler: function (newvalue, oldvalue) {
        if (newvalue != oldvalue) {
          this.GetEventList();
        }
      },
    },
    "selectParams.city": {
      handler: function (newvalue, oldvalue) {
        if (newvalue != oldvalue) {
          this.GetEventList();
        }
      },
    },
    "selectParams.status": {
      handler: function (newvalue, oldvalue) {
        if (newvalue != oldvalue) {
          this.GetEventList();
        }
      },
    },
    "selectParams.remark": {
      handler: function (newvalue, oldvalue) {
        if (newvalue != oldvalue) {
          this.GetEventList();
        }
      },
    },
  },
  created() {
    this.base = bases;
    this.$store.dispatch("updateCurrentIndex", 3);
    this.GetEventList();
    this.$store.dispatch("getCommonTypeDesk", 40).then((res) => {
      this.EventTypeList = res; //活動類型
    });
    this.$store.dispatch("getCommonTypeDesk", 50).then((res) => {
      this.EventStatusList = res; //活動狀態
    });
    this.$store.dispatch("getCommonTypeDesk", 60).then((res) => {
      this.EventRemarkList = res; //活動附注
    });
    this.$store.dispatch("getCommonTypeDesk", 30).then((res) => {
      this.EventCityList = res; //城市
    });
  },
  methods: {
    refresh() {
      this.$router.go(0);
    },
    addfavorite(tid, type, Ftype, longid) {
      let params = {
        sgL_DevicesType: 0,
        sgL_MasterSort: type, //类型
        sgL_PG_Coid: tid, //图册、影片、文章、活动的id
        sgL_Fav_FType: Ftype, //图册：0，图片：1，影片：2,文章：4，活动：3
        sgL_Fav_FBelongidc: longid, //图片id
      };
      this.$store.dispatch("addfavorite", params).then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
          this.GetEventList();
          // if (Ftype == 0) {
          //   this.getPicturePublish();
          // } else if (Ftype == 2) {
          //   this.getVideoPublish();
          // }
        }
      });
    },
    GetEventList() {
      let params = {
        sgL_Title: this.selectParams.title,
        sgL_ActivityDate: this.selectParams.data,
        sgL_TypeId: this.selectParams.type,
        sgL_NotesId: this.selectParams.remark,
        sgL_Status: this.selectParams.status,
        sgL_AreaId: this.selectParams.city,
        MaxResultCount: 10000000,
      };
      let list1 = [];
      let list2 = [];
      this.$api.EventApi.GetEventListDesk(params).then((res) => {
        if (res.data.success) {
          this.floading = false;
          const result = res.data.result;
          for (let i = 0; i < result.length; i++) {
            let data1 = { ...result[i] };
            data1.datalist = [];
            let data2 = { ...result[i] };
            data2.datalist = [];
            for (let j = 0; j < result[i].datalist.length; j++) {
              const info = result[i].datalist[j];
              if (
                info.sgL_ActivityDate
                  .replace(new RegExp("T00:00:00", "g"), "")
                  .replace(new RegExp("/", "g"), "-") < this.getNowTime()
              ) {
                data1.datalist.push(info);
              } else {
                data2.datalist.push(info);
              }
            }
            /* if (data1.datalist.length > 0) {
              this.activeList2.push(data1);
            }
            if (data2.datalist.length > 0) {
              this.activeList.push(data2);
            } */
            if (data1.datalist.length > 0) {
              list1.push(data1);
            }
            if (data2.datalist.length > 0) {
              list2.push(data2);
            }
          }
          this.activeList2 = list1;
          this.activeList = list2;
          this.loading = false;
        }
      });
    },
    toSendMessage() {
      this.$router.push({ name: "sendmessage" });
    },
    clear() {
      this.$refs.selectParams.resetFields(); //清空表单
    },
    getNowTime(isYMD) {
      var date = new Date();
      //年 getFullYear()：四位数字返回年份
      var year = date.getFullYear(); //getFullYear()代替getYear()
      //月 getMonth()：0 ~ 11
      var month = date.getMonth() + 1;
      //日 getDate()：(1 ~ 31)
      var day = date.getDate();
      //时 getHours()：(0 ~ 23)
      var hour = date.getHours();
      //分 getMinutes()： (0 ~ 59)
      var minute = date.getMinutes();
      //秒 getSeconds()：(0 ~ 59)
      var second = date.getSeconds();

      var time =
        year +
        "-" +
        this.addZero(month) +
        "-" +
        this.addZero(day) +
        " " +
        this.addZero(hour) +
        ":" +
        this.addZero(minute) +
        ":" +
        this.addZero(second);
      if (isYMD) {
        time = year + "-" + this.addZero(month) + "-" + this.addZero(day);
      }
      return time;
    },
    addZero(s) {
      return s < 10 ? "0" + s : s;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Activitys/ActiveList.vue